import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Dashboard`, method: 'GET', body: null, token: token})
}